module.exports = __webpack_public_path__ + "static/media/doctor.3a2ec816.jpg";